module.exports = __webpack_public_path__ + "media/images/brands/crosspoint-1899f0ce39adaf188cb236a2d7b39b21.svg";